<template>
  <div class="empty">
    <img v-if="type === 1" src="@/assets/empty/ic_wuxiaoxi.png" class="img" >
    <img v-if="type === 2" src="@/assets/empty/ic_wusousuo.png" class="img" >
    <img v-if="type === 3" src="@/assets/empty/ic_wuxingxi.png" class="img" >
    <img v-if="type === 4" src="@/assets/empty/ic_wangluo.png" class="img" >
    <div class="tip">{{type === 1 ? '暂无消息' : type === 2 ? '当前搜索无结果' : type === 3 ? '暂无数据' : '网络出问题了'}}</div>
    <div class="tip" v-if="type === 2">请核对信息后进行搜索</div>
    <div class="reload" v-if="type === 4" @click="onReload">刷新试试</div>
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            type: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
            };
        },
        watch: {
        },
        computed: {
        },
        methods: {
            onReload () {
                this.$emit('onReload')
            }
        },
        mounted () {}
    };
</script>

<style scoped lang="less">
.empty {
  flex: 1;
  width: 100%;
  // height: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .img {
    width: 74px;
    margin-bottom: 24px;
  }
  line-height: 14px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  .tip {
    margin-bottom: 10px;
    color: rgba(153, 153, 153, 1);
  }
  .reload {
    color: #36b374;
  }
}
</style>
